import React,{Component} from 'react';

class Notification extends Component{

  constructor(props){
    super(props);
    
  }

  render(){
    if(this.props.showNotification === true ){
      return (

        <div className="notification">
         {this.props.notification}

        </div>
      )
    }else{
      return "";
    }
  }
}
export default Notification;
